const sections = {
  '서비스 섹션': ['브랜드 전략', 'SNS 마케팅', '퍼포먼스 광고', '콘텐츠 제작', 'SEO / 검색', 'CRM 마케팅'],
  '회사 정보':   ['회사소개', '팀 소개', '채용 공고', '블로그 / 뉴스'],
  '독자 지원':   ['포트폴리오', '고객 후기', 'FAQ', '무료 상담'],
};

export default function Footer() {
  return (
    <footer className="bg-ink text-paper">
      {/* Masthead footer */}
      <div className="border-b-4 border-red py-8 px-6">
        <div className="max-w-7xl mx-auto text-center">
          <div className="font-headline font-black text-paper mb-1"
            style={{ fontSize:'clamp(28px,4vw,56px)' }}>
            CARATINGS
          </div>
          <p className="font-mono text-xs text-paper/30 tracking-widest">
            마케팅 전략 · 데이터 기반 성장 · 서울특별시 · 2018년 창간
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          {/* Brand column */}
          <div>
            <p className="font-mono text-xs text-paper/30 tracking-widest uppercase mb-4">편집국</p>
            <p className="font-serif text-sm text-paper/60 leading-relaxed mb-5">
              caratings는 데이터와 창의성으로 브랜드의 디지털 성장을 이끄는 마케팅 에이전시입니다. 2018년 설립 이후 500개 이상의 브랜드와 함께했습니다.
            </p>
            <div className="flex gap-3">
              {['IG', 'YT', 'LI'].map(s => (
                <a key={s} href="/#"
                  className="font-mono text-xs border border-paper/20 hover:border-red hover:text-red text-paper/40 px-2.5 py-1.5 transition-colors duration-200">
                  {s}
                </a>
              ))}
            </div>
          </div>

          {Object.entries(sections).map(([title, items]) => (
            <div key={title}>
              <p className="font-mono text-xs text-paper/30 tracking-widest uppercase mb-4">{title}</p>
              <ul className="space-y-2.5">
                {items.map(item => (
                  <li key={item}>
                    <a href="/#"
                      className="font-sans text-sm text-paper/50 hover:text-paper transition-colors duration-200">
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-paper/10 pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="font-mono text-xs text-paper/25">
            © 2024 THE CARATINGS. All rights reserved.
          </p>
          <div className="flex gap-6">
            {['개인정보처리방침', '이용약관', '광고 문의'].map(item => (
              <a key={item} href="/#"
                className="font-mono text-xs text-paper/25 hover:text-paper/60 transition-colors duration-200">
                {item}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
